import React from 'react';
import PropTypes from 'prop-types';
import { styles, Typography } from '../../index';
import classNames from 'classnames';

const WellDetail = props => {
  const classes = useStyles();
  return (
    <Typography
      variant={'body1'}
      className={classNames(classes.root, props.className)}
      data-testid={props['data-testid']}>
      {props.children}
    </Typography>
  );
};

WellDetail.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
};

const useStyles = styles.makeStyles(
  (theme) => ({
    root: {
      textAlign: 'center',
      fontStyle: 'normal',
      fontWeight: 'normal',
      letterSpacing: '0.25px',
      fontSize: 14,
      color: '#717173'
    },
  })
);


export default WellDetail;
